import type { Properties } from 'posthog-js'
import posthog from 'posthog-js'
import Service from '@ember/service'
import config from 'district-ui-client/config/environment'

/*
 * Analytics Service using Posthog
 */

export default class AnalyticsService extends Service {
  setup() {
    if (config.posthog.enabled) {
      posthog.init(config.posthog.token, {
        loaded: () => {
          this.register({
            emberGitSha: config.APP.emberGitSha,
          })
        },
      })
    }
  }

  /**
   * Manually capture an event
   *
   * **Note** Page transition events are automatically captured
   */
  capture(eventName: string, options?: Properties) {
    posthog.capture(eventName, options)
  }

  /**
   * ```
   * Register key value pairs to be sent with every subsequent event
   *
   * posthog.register({
   *   'icecream pref': 'vanilla',
   *   team_id: 22,
   * })
   * ```
   *
   * These properties can later be used as filters
   */
  register(data: Properties) {
    posthog.register(data)
  }

  clearUser = () => {
    posthog.reset()
  }
}

declare module '@ember/service' {
  interface Registry {
    analytics: AnalyticsService
  }
}
